package org.example.zone360.models

import kotlinx.serialization.Serializable


@Serializable
data class DeleteKeywordSessionRequest(
    val data: String
)